// 模块动画
export default {
  namespaced: true,
  state: {
    queue: [],
    isInitOutList: [],
    implement:[]
  },
  actions: {
    recordOutKey ({ commit }, key) { // 记录当前流中已初始化过得模块的key
      commit('RECORD_OUT_KEY', key)
    }
  },
  mutations: {
    ['RECORD_OUT_KEY'] (state, key) {
      if (!state.isInitOutList.find(item => item === key)) state.isInitOutList.push(key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/module_animation.js